<template>
<div class="chapter">
<div class="inner_page">
<p class="imagey"><a id="page_xii"></a><a id="page_1"></a><img alt="image" src="images/common1.jpg"/></p>
<p class="blockquotex"><em>Think of those old, enduring connections found in all flesh—the channeling wires and threads, vacuoles, granules, plasma and pods, purple veins, ascending boles and coral sapwood (sugar- and light-filled), those common ligaments, filaments, fibers and canals</em>.</p>
<p class="chapauthorx">—from “The Family Is All There Is” by Pattiann Rogers</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm3.vue?67ab27b6